import { motion } from "framer-motion";
import { Calendar, ArrowDownRight } from "lucide-react";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative px-6 md:px-16 lg:px-32 py-32 md:py-48 overflow-hidden"
    >
      {/* Heavy neon glow, desktop only */}
      <div className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] neon-glow-pink neon-pulse pointer-events-none" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-10 h-px bg-[#F4C75E]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#F4C75E] font-bold">
            08 / Let's Build
          </span>
          <span className="w-10 h-px bg-[#F4C75E]" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-bold uppercase tracking-tighter leading-[0.88] text-4xl md:text-5xl lg:text-7xl"
        >
          Ready when<br />
          <span className="text-[#F4C75E]">you are.</span>
        </motion.h2>

        <p className="mt-8 text-sm md:text-base text-[#A3A3A3] max-w-xl leading-relaxed">
          Let's talk about your show, your distribution goals and the media stack we can build around every episode.
        </p>

        <div className="mt-12 flex justify-center">
          <a
            href="https://calendly.com/darshan081200/30min"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-calendly-button"
            className="group bg-[#F4C75E] text-black font-bold uppercase tracking-[0.2em] text-xs md:text-sm px-10 py-5 hover:bg-white hover:text-black transition-all duration-300 shadow-[0_0_40px_rgba(244,199,94,0.4)] hover:shadow-[0_0_60px_rgba(255,255,255,0.5)] inline-flex items-center justify-center gap-3"
          >
            <Calendar className="w-4 h-4" />
            Work With Us
            <ArrowDownRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </a>
        </div>

        <div className="mt-16 pt-10 border-t border-[#222] w-full grid grid-cols-1 md:grid-cols-2 gap-8">
          {[
            { l: "Based In", v: "Bangalore · Remote" },
            { l: "Response Time", v: "Within 24 hours" },
          ].map((c, i) => (
            <div key={i} data-testid={`contact-info-${i}`} className="text-left md:text-center">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#666] mb-2">
                {c.l}
              </div>
              <div className="text-sm md:text-base text-[#F5F5F5]">{c.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
